import React from 'react';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { defaultShouldDehydrateQuery } from '@tanstack/react-query';
import { persister, renegkitQueryClient } from '../../services/query/query.service';
import { QUERY_OFFERS_EXPERIENCE_KEY } from '../../constants/queryKeys';

export const RenegQueryProvider = ({ children }: any) => (
  <PersistQueryClientProvider
    client={renegkitQueryClient}
    persistOptions={{
      persister,
      // The experience decision must NOT be resurrected from localStorage across
      // sessions: it polls fresh each session and re-emits its decision. Persist
      // everything else (agreements) as before.
      dehydrateOptions: {
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) && query.queryKey[0] !== QUERY_OFFERS_EXPERIENCE_KEY,
      },
    }}
  >
    {children}
  </PersistQueryClientProvider>
);
